import { Injectable } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { ExerciseFromDbDetailComponent } from './exercise-from-db-detail.component';
import { DbExercise } from 'src/models/db-exercises.model';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root', // This makes the service a singleton and available application-wide
})
export class ExerciseFromDbDetailController {
  constructor(
    private modalController: ModalController,
    private location: Location,
    public toastController: ToastController
  ) {}

  async presentModal(detail: DbExercise) {
    const modal = await this.modalController.create({
      component: ExerciseFromDbDetailComponent,
      componentProps: {
        detail: detail,
      },
    });

    return await modal.present();
  }

  shareDetail(detailId: string): void {
    // Construct the full URL for the detail page
    const fullPath = this.location.prepareExternalUrl(
      `home/exercises-preview/${detailId}`
    );
    const baseUrl = window.location.origin;
    const fullUrl = `${baseUrl}${fullPath}`;

    // Copy the URL to the clipboard
    navigator.clipboard
      .writeText(fullUrl)
      .then(() => {
        this.presentToastAtTop();
      })
      .catch((err) => {
        console.error('Failed to copy: ', err);
      });
  }

  private async presentToastAtTop() {
    const toast = await this.toastController.create({
      message: 'Detail URL copied to clipboard!',
      duration: 2000, // Toast duration in milliseconds
      position: 'top', // Positions the toast at the top of the screen
    });
    await toast.present();
  }
}
